import React from "react";

export function GenericTableCellRenderer(props) {
	const {children, className, key} = props;
	return <td key={key} className={className ?? ""}>
		{children}
	</td>;
}
